import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  LinearProgress,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';
import { getToastErrors } from '~/helpers/errorsRequest';
import api from '~/services/api';
import { changePhysicalTankData } from '~/store/modules/EdicaoOperacao/Turno/actions';

import * as S from './styles';

export default function Accounting({ data, editable, loading }) {
  const dispatch = useDispatch();

  const handleChangeValueInput = useCallback(({ key, value }) => {
    dispatch(changePhysicalTankData(key, value));
  }, []);

  const handleChangeInitialHeight = useCallback(
    async ({ item, value, key, input, vars }) => {
      const inForm = document.getElementById(`${input}${item.idtanquefisico}`);

      try {
        const response = await api.get(
          `/arqueacoes/${item.idarqueacao}/${item.idposto}/${value}`
        );

        inForm.value = response.data.altura;

        const items = { ...item };

        items[vars.other] = response.data.volume;
        items[vars.current] = response.data.altura;

        handleChangeValueInput({ key, value: items });
      } catch (err) {
        inForm.value = '';
        inForm.focus();

        getToastErrors(err);
      }
    },
    []
  );

  return (
    <S.WrapperTabela>
      {loading && <LinearProgress />}

      <S.WrapperTitle>
        <Typography>{t('s.operacao.turno.estoquecontabil')}</Typography>
      </S.WrapperTitle>

      <TableContainer>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell rowSpan={2} align="center" variant="head">
                {t('c.menu.stock.tanque')}
              </TableCell>
              <TableCell colSpan={5} align="center" variant="head">
                {t('s.operacao.turno.abertura')}
              </TableCell>
              <TableCell colSpan={5} align="center" variant="head">
                {t('s.operacao.turno.fechamento')}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell variant="head">
                {t('s.operacao.turno.alturatanquefisico')}
              </TableCell>
              <TableCell variant="head">
                {t('s.operacao.turno.volumetanquefisico')}
              </TableCell>
              <TableCell variant="head">
                {t('s.operacao.turno.alturaaguatanquefisico')}
              </TableCell>
              <TableCell variant="head">
                {t('s.operacao.turno.volumeaguatanquefisico')}
              </TableCell>
              <TableCell variant="head">
                {t('s.relatorio.geral.volumeambiente')}
              </TableCell>
              <TableCell variant="head">
                {t('s.operacao.turno.alturatanquefisico')}
              </TableCell>
              <TableCell variant="head">
                {t('s.operacao.turno.volumetanquefisico')}
              </TableCell>
              <TableCell variant="head">
                {t('s.operacao.turno.alturaaguatanquefisico')}
              </TableCell>
              <TableCell variant="head">
                {t('s.operacao.turno.volumeaguatanquefisico')}
              </TableCell>
              <TableCell variant="head">
                {t('s.relatorio.geral.volumeambiente')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, key) => (
              <TableRow key={key}>
                <TableCell variant="body">{row.codigotanquefisico}</TableCell>
                <TableCell variant="body">
                  {editable ? (
                    <input
                      type="number"
                      id={`p.in.${row.idtanquefisico}`}
                      defaultValue={row.alturainicioturnotanque}
                      onKeyUp={({ target, key: bindKey }) =>
                        bindKey === 'Enter' &&
                        handleChangeInitialHeight({
                          item: row,
                          value: target.value,
                          key,
                          input: 'p.in.',
                          vars: {
                            current: 'alturainicioturnotanque',
                            other: 'volmedidoinicioturnotanque',
                          },
                        })
                      }
                      onBlur={({ target }) =>
                        handleChangeInitialHeight({
                          item: row,
                          value: target.value,
                          key,
                          input: 'p.in.',
                          vars: {
                            current: 'alturainicioturnotanque',
                            other: 'volmedidoinicioturnotanque',
                          },
                        })
                      }
                    />
                  ) : (
                    number(row.alturainicioturnotanque, 4)
                  )}
                </TableCell>
                <TableCell variant="body">
                  {number(row.volmedidoinicioturnotanque, 2)}
                </TableCell>
                <TableCell variant="body">
                  {editable ? (
                    <input
                      id={`a.in.${row.idtanquefisico}`}
                      type="number"
                      defaultValue={row.alturaaguainicioturnotanque}
                      onKeyUp={({ target, key: bindKey }) =>
                        bindKey === 'Enter' &&
                        handleChangeInitialHeight({
                          item: row,
                          value: target.value,
                          key,
                          input: 'a.in.',
                          vars: {
                            current: 'alturaaguainicioturnotanque',
                            other: 'volmedidoaguainicioturnotanque',
                          },
                        })
                      }
                      onBlur={({ target }) =>
                        handleChangeInitialHeight({
                          item: row,
                          value: target.value,
                          key,
                          input: 'a.in.',
                          vars: {
                            current: 'alturaaguainicioturnotanque',
                            other: 'volmedidoaguainicioturnotanque',
                          },
                        })
                      }
                    />
                  ) : (
                    number(row.alturaaguainicioturnotanque, 4)
                  )}
                </TableCell>
                <TableCell variant="body">
                  {number(row.volmedidoaguainicioturnotanque, 2)}
                </TableCell>
                <TableCell variant="head" align="right">
                  {number(
                    row.volmedidoinicioturnotanque -
                      row.volmedidoaguainicioturnotanque,
                    2
                  )}
                </TableCell>
                <TableCell variant="body">
                  {editable ? (
                    <input
                      id={`p.fn.${row.idtanquefisico}`}
                      type="number"
                      defaultValue={row.alturafimturnotanque}
                      onKeyUp={({ target, key: bindKey }) =>
                        bindKey === 'Enter' &&
                        handleChangeInitialHeight({
                          item: row,
                          value: target.value,
                          key,
                          input: 'p.fn.',
                          vars: {
                            current: 'alturafimturnotanque',
                            other: 'volmedidofimturnotanque',
                          },
                        })
                      }
                      onBlur={({ target }) =>
                        handleChangeInitialHeight({
                          item: row,
                          value: target.value,
                          key,
                          input: 'p.fn.',
                          vars: {
                            current: 'alturafimturnotanque',
                            other: 'volmedidofimturnotanque',
                          },
                        })
                      }
                    />
                  ) : (
                    number(row.alturafimturnotanque, 4)
                  )}
                </TableCell>
                <TableCell variant="body">
                  {number(row.volmedidofimturnotanque, 2)}
                </TableCell>
                <TableCell variant="body">
                  {editable ? (
                    <input
                      id={`a.fn.${row.idtanquefisico}`}
                      type="number"
                      defaultValue={row.alturaaguafimturnotanque}
                      onKeyUp={({ target, key: bindKey }) =>
                        bindKey === 'Enter' &&
                        handleChangeInitialHeight({
                          item: row,
                          value: target.value,
                          key,
                          input: 'a.fn.',
                          vars: {
                            current: 'alturaaguafimturnotanque',
                            other: 'volmedidoaguafimturnotanque',
                          },
                        })
                      }
                      onBlur={({ target }) =>
                        handleChangeInitialHeight({
                          item: row,
                          value: target.value,
                          key,
                          input: 'a.fn.',
                          vars: {
                            current: 'alturaaguafimturnotanque',
                            other: 'volmedidoaguafimturnotanque',
                          },
                        })
                      }
                    />
                  ) : (
                    number(row.alturaaguafimturnotanque, 4)
                  )}
                </TableCell>
                <TableCell variant="body">
                  {number(row.volmedidoaguafimturnotanque, 2)}
                </TableCell>
                <TableCell variant="head">
                  {number(
                    row.volmedidofimturnotanque -
                      row.volmedidoaguafimturnotanque,
                    2
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </S.WrapperTabela>
  );
}

Accounting.propTypes = {
  editable: PropTypes.bool,
  loading: PropTypes.bool,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      codigotanquefisico: PropTypes.string.isRequired,
      alturainicioturnotanque: PropTypes.number.isRequired,
      volmedidoinicioturnotanque: PropTypes.number.isRequired,
      volmedido20inicioturnotanque: PropTypes.number.isRequired,
      alturafimturnotanque: PropTypes.number.isRequired,
      volmedidofimturnotanque: PropTypes.number.isRequired,
      volmedido20fimturnotanque: PropTypes.number.isRequired,
      alturaaguainicioturnotanque: PropTypes.number.isRequired,
      volmedidoaguainicioturnotanque: PropTypes.number.isRequired,
      alturaaguafimturnotanque: PropTypes.number.isRequired,
      volmedidoaguafimturnotanque: PropTypes.number.isRequired,
    })
  ).isRequired,
};

Accounting.defaultProps = {
  editable: false,
  loading: false,
};
